import React, { createContext, useContext, useState, useCallback, useEffect } from 'react';

// Lightweight context to drive the mobile sidebar drawer.
// DashboardLayout provides; Sidebar consumes; the hamburger button in the
// top header also consumes via the `useSidebar()` hook.

const SidebarContext = createContext({ open: false, setOpen: () => {}, toggle: () => {} });

export const SidebarProvider = ({ children }) => {
  const [open, setOpen] = useState(false);
  const toggle = useCallback(() => setOpen((v) => !v), []);

  // Close on Escape key for keyboard users
  useEffect(() => {
    if (!open) return;
    const onKey = (e) => { if (e.key === 'Escape') setOpen(false); };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [open]);

  // Lock body scroll while drawer is open on mobile
  useEffect(() => {
    if (open) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
    return () => { document.body.style.overflow = ''; };
  }, [open]);

  return (
    <SidebarContext.Provider value={{ open, setOpen, toggle }}>
      {children}
    </SidebarContext.Provider>
  );
};

export const useSidebar = () => useContext(SidebarContext);
